import { render, staticRenderFns } from "./ShowTowerComponent.vue?vue&type=template&id=27af96ef"
import script from "./ShowTowerComponent.vue?vue&type=script&lang=js"
export * from "./ShowTowerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports